export default __webpack_public_path__ + "56199d8a20759b189fd83a6f350609c5.svg";